import {createAction, props} from '@ngrx/store';
import {UserPublic} from '../../shared/models/userPublic.interface';
import {Transaction} from '../../shared/models/transaction.interface';
import {TransactionListing} from '../../shared/models/transactionListing.interface';

export const setPaymentParams = createAction('[Pay] starting payment process by setting payment params', props<{ amount: number, currencyId: string, transaction?: Transaction, listing?: TransactionListing, receiver?: UserPublic }>());
